import { Outlet } from 'react-router-dom';
import { AppointmentHeader } from '@/components/AppointmentHeader';
import { useTranslation } from 'react-i18next';

/**
 * IsabelLayout component that renders the layout for the Isabel appointment scheduling flow.
 * @returns The rendered IsabelLayout component.
 */
export const IsabelLayout = () => {
  const { t } = useTranslation();
  return (
    <div>
      <AppointmentHeader
        variant={'scheduled'}
        text={t('isabel.tell-us-why-you-re-here')}
      />
      <Outlet />
    </div>
  );
};
